import { useContext } from "react";
import { Context } from "./context";

export function useModelId() {
  const context = useContext(Context);

  if (!context) {
    throw new Error("useProcessId must be used within a ProcessIdProvider");
  }
  return context;
}
